/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_DASHBOARD_ATTENDANCE_SUCCESS,
  LOAD_DASHBOARD_ATTENDANCE_ERROR,
  LOAD_DASHBOARD_CHECKINOUT_SUCCESS,
  LOAD_DASHBOARD_CHECKINOUT_ERROR,
  LOAD_BIRTHDAY_LIST_SUCCESS,
  LOAD_BIRTHDAY_LIST_ERROR,
  LOAD_HOLIDAY_LIST_SUCCESS,
  LOAD_HOLIDAY_LIST_ERROR,
  LOAD_YEARLY_LEAVE_SUCCESS,
  LOAD_YEARLY_LEAVE_ERROR,
  LOAD_DAILY_PERCENTAGE_LIST_SUCCESS,
  LOAD_DAILY_PERCENTAGE_LIST_ERROR,
  LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS,
  LOAD_WEEKLY_PERCENTAGE_LIST_ERROR,
  LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS,
  LOAD_MONTHLY_PERCENTAGE_LIST_ERROR,
  LOAD_EMPLOYEE_STATUS_SUCCESS,
  LOAD_EMPLOYEE_STATUS_ERROR,
  LOAD_ATTENDANCE_OVERVIEW_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_ERROR,
  LOAD_DEPARTMENT_SUCCESS,
  LOAD_DEPARTMENT_ERROR,
  LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS,
  LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR,
  LOAD_LATE_SUCCESS,
  LOAD_LATE_ERROR,
  LOAD_EMPLOYEE_TYPE_SUCCESS,
  LOAD_EMPLOYEE_TYPE_ERROR
} from "./constants";

const initialState = {
  birthday_list: [],
  Dashboardattendence_list: [],
  checkinOut_list: [],
  holiday_list: [],
  Yearlyleave_list: [],
  daily_list: [],
  weekly_list: [],
  monthly_list: [],
  employeeStatus_list: [],
  AttendanceOverview_list: [],
  attendanceTodayOverview_list: [],
  attendanceThisWeekOverview_list: [],
  attendanceThisMonthOverview_list: [],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
  department_list: [],
  late_list: [],
  employeeType_list: []
};

const Reducer = (
  state = initialState,
  {
    type,
    Dashboardattendence_list,
    checkinOut_list,
    birthday_list,
    holiday_list,
    Yearlyleave_list,
    daily_list,
    weekly_list,
    monthly_list,
    employeeStatus_list,
    AttendanceOverview_list,
    attendanceTodayOverview_list,
    attendanceThisWeekOverview_list,
    attendanceThisMonthOverview_list,
    error,
    department_list,
    late_list,
    employeeType_list
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_DASHBOARD_ATTENDANCE_SUCCESS:
        draft.Dashboardattendence_list = Dashboardattendence_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DASHBOARD_CHECKINOUT_SUCCESS:
        draft.checkinOut_list = checkinOut_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_BIRTHDAY_LIST_SUCCESS:
        draft.birthday_list = birthday_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_HOLIDAY_LIST_SUCCESS:
        draft.holiday_list = holiday_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_YEARLY_LEAVE_SUCCESS:
        draft.Yearlyleave_list = Yearlyleave_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DAILY_PERCENTAGE_LIST_SUCCESS:
        draft.daily_list = daily_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_WEEKLY_PERCENTAGE_LIST_SUCCESS:
        draft.weekly_list = weekly_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_MONTHLY_PERCENTAGE_LIST_SUCCESS:
        draft.monthly_list = monthly_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EMPLOYEE_STATUS_SUCCESS:
        draft.employeeStatus_list = employeeStatus_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ATTENDANCE_OVERVIEW_SUCCESS:
        draft.AttendanceOverview_list = AttendanceOverview_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DEPARTMENT_SUCCESS:
        draft.department_list = department_list;
        draft.error = false;
        draft.success = false;
        break;

      case LOAD_ATTENDANCE_OVERVIEW_TODAY_SUCCESS:
        draft.attendanceTodayOverview_list = attendanceTodayOverview_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ATTENDANCE_OVERVIEW_THISWEEK_SUCCESS:
        draft.attendanceThisWeekOverview_list = attendanceThisWeekOverview_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ATTENDANCE_OVERVIEW_THISMONTH_SUCCESS:
        draft.attendanceThisMonthOverview_list =
          attendanceThisMonthOverview_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LATE_SUCCESS:
        draft.late_list =
          late_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_EMPLOYEE_TYPE_SUCCESS:
        draft.employeeType_list =
          employeeType_list;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LATE_ERROR:
      case LOAD_DEPARTMENT_ERROR:
      case LOAD_BIRTHDAY_LIST_ERROR:
      case LOAD_DASHBOARD_CHECKINOUT_ERROR:
      case LOAD_DASHBOARD_ATTENDANCE_ERROR:
      case LOAD_YEARLY_LEAVE_ERROR:
      case LOAD_DAILY_PERCENTAGE_LIST_ERROR:
      case LOAD_WEEKLY_PERCENTAGE_LIST_ERROR:
      case LOAD_MONTHLY_PERCENTAGE_LIST_ERROR:
      case LOAD_ATTENDANCE_OVERVIEW_ERROR:
      case LOAD_EMPLOYEE_STATUS_ERROR:
      case LOAD_HOLIDAY_LIST_ERROR:
      case LOAD_ATTENDANCE_OVERVIEW_THISWEEK_ERROR:
      case LOAD_ATTENDANCE_OVERVIEW_THISMONTH_ERROR:
      case LOAD_EMPLOYEE_TYPE_ERROR :
      case LOAD_ATTENDANCE_OVERVIEW_TODAY_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
